import { Box, Button, Container, Heading, Text, VStack } from '@chakra-ui/react'
import React from 'react'

const Subscribepage = () => {
  return (
    <Container h='90vh' p='16'>
        <Heading children='Welcome' my='8' textAlign={'center'} />
        <VStack boxShadow={'lg'} alignItems='stretch' borderRadius={'lg'} spacing='0'>
            <Box bg='yellow.400' p={'4'} css={{borderRadius:'8px 8px 0 0'}}>
                <Text children={'Premium Pack @ 199 INR'} color='black' />
            </Box>
            <Box p='4'>
                <VStack textAlign={'center'} px='8' mt={'4'} spacing='8'>
                    <Text color={'gray'} children={'Get access to all courses by joining premium pack'}/>
                    <Heading size='md' children={'199INR only'} />
                </VStack>
                <Button my={'8'} w='full' colorScheme={'yellow'}>Buy Now</Button>
            </Box>
            <Box bg='blackAlpha.600' p='4' css={{borderRadius: '0 0 8px 8px'}}>
                <Heading color='white' textTransform={'uppercase'} size='sm' children={'100% refund at cancellation'} />
            </Box>
        </VStack>
    </Container>
  )
}

export default Subscribepage